<template>
  <v-row class="mx-2">
    <v-col :style="{ 'padding-left': padding }">
      <div class="">
        <CardsView
          class="mt-5"
          :items="items"
          :openDialog="openDialog"
          :title="title"
          @goToItem="goToItem"
          :showAdd="false"
          :showDelete="false"
          :showEdit="false"
        />
      </div>
    </v-col>
  </v-row>
</template>
<script>
import groups from "@/store/permisosDeAcceso/groups";
import holidays from "@/store/permisosDeAcceso/holidays";
import schedules from "@/store/permisosDeAcceso/accessPermissions.js";
import CardsView from "@/components/Complement/CardsView.vue";
import employeesPermissions from "@/store/permisosDeAcceso/employees";
export default {
  components: { CardsView },
  data: () => ({
    showCard: true,
  }),
  props: {
    itemId: Number,
  },

  mounted() {},
  computed: {
    permissions() {
      return schedules.state.permissions;
    },
    segment() {
      return schedules.state.segments;
    },
    padding() {
      return schedules.state.paddingNav;
    },
    title() {
      const parsedId = parseInt(this.itemId);
      const schedule = this.permissions.find(
        (schedule) => schedule.id === parsedId
      );
      return schedule ? schedule.name : "";
    },

    items() {
      return [
        { name: "Segmentos" },
        { name: "Empleados" },
        { name: "Grupos" },
        { name: "Grupos de feriados" },
      ];
    },
  },

  methods: {
    cardView(value) {
      this.showCard = value;
    },

    goToItem(item) {
      switch (item.name) {
        case "Segmentos":
          schedules.commit("setPermissionId", this.itemId);
          schedules.dispatch("getSegments").then(() => {
            schedules.dispatch("handleShowWindow", "segment");
          });
          break;
        case "Empleados":
          employeesPermissions.commit("setPermissionId", this.itemId);
          employeesPermissions.dispatch("getEmployees").then(() => {
            schedules.dispatch("handleShowWindow", "employees");
          });
          break;
        case "Grupos":
          groups.commit("setPermissionId", this.itemId);
          groups.dispatch("getGroups").then(() => {
            schedules.dispatch("handleShowWindow", "groups");
          });
          break;
        case "Grupos de feriados":
          holidays.commit("setPermissionId", this.itemId);
          holidays.dispatch("getHolidaysId").then(() => {
            schedules.dispatch("handleShowWindow", "holiday");
          });
          break;

        default:
          break;
      }
    },
    openDialog() {},
  },
};
</script>
<style scoped></style>
